// Helpers de contenu bilingue (FR par défaut, NL si disponible).

export const pickL = (obj, field, lang) => {
  if (!obj) return "";
  if (lang === "nl") {
    const v = obj[`${field}_nl`];
    if (Array.isArray(v) ? v.length : v) return v;
  }
  return obj[field];
};

const CAT_NL = { Tous: "Alle", Visage: "Gezicht", Corps: "Lichaam", Cheveux: "Haar", Coffrets: "Geschenksets" };

export const catLabel = (cat, lang) => (lang === "nl" ? CAT_NL[cat] || cat : cat);
